import type { Reducer } from 'redux';

import type { SubscribeTopicAction, UnsubscribeTopicAction } from '../../domains/topicSubscription/actions.types';
import type { Topic } from '../types';

import type { TopicsSubscribed } from './types';

const subscribeTopics = (state: TopicsSubscribed, topicIds: Topic['id'][]) => {
  const currentSubscribedTopics = state.fulfilled?.topicIds ?? [];
  const cursor = state.fulfilled?.cursor ?? null;
  const hasNextPage = state.fulfilled?.hasNextPage ?? false;

  const newSubscribedTopicIds = [...currentSubscribedTopics, ...topicIds];

  return { ...state, fulfilled: { cursor, hasNextPage, topicIds: newSubscribedTopicIds } };
};

const unsubscribeTopics = (state: TopicsSubscribed, topicIds: Topic['id'][]) => {
  const currentSubscribedTopics = state.fulfilled?.topicIds ?? [];
  const cursor = state.fulfilled?.cursor ?? null;
  const hasNextPage = state.fulfilled?.hasNextPage ?? false;

  if (currentSubscribedTopics.length === 0) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      cursor,
      hasNextPage,
      topicIds: currentSubscribedTopics.filter((id: Topic['id']) => !topicIds.includes(id)),
    },
  };
};

const initialState: TopicsSubscribed = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type TopicsSubscribedAction = SubscribeTopicAction | UnsubscribeTopicAction;

const reducer: Reducer<TopicsSubscribed, TopicsSubscribedAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPIC.SUBSCRIBE_FULFILLED':
      return subscribeTopics(state, action.payload.topicIds);
    case 'TOPIC.UNSUBSCRIBE_FULFILLED':
      return unsubscribeTopics(state, action.payload.topicIds);
    default:
      return state;
  }
};

export default reducer;
